import React, { Component } from "react";
import { Avatar, Button, Card, Popconfirm, Tooltip } from "antd";
import { FormattedMessage, injectIntl } from "react-intl";
import { withTheme } from "styled-components";
import AppContext from "../../../AppContext";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

const { Meta } = Card;

class Header extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      deleteVisible: false,
      editVisible: false,
    };
  }

  getInitials = () => {
    if (this.props.contact_info) {
      let firstName = this.props.contact_info?.about?.first_name ?? "",
        lastName = this.props.contact_info?.about?.last_name ?? "";
      if (firstName !== "" || lastName !== "") {
        return firstName?.charAt(0).toUpperCase() + lastName?.charAt(0).toUpperCase();
      }
      return "..";
    }
    return "..";
  };

  getName = () => {
    if (this.props.contact_info) {
      let firstName = this.props.contact_info?.about?.first_name ?? this.props.contact_info?.first_name ?? "",
        lastName = this.props.contact_info?.about?.last_name ?? this.props.contact_info?.last_name ?? "";
      if (firstName !== "" || lastName !== "") {
        return firstName + " " + lastName;
      }
      let busName = this.props.contact_info?.about?.bus_name ?? "";
      if (busName !== "") {
        return busName;
      }
      return this.context.capitalizeStr(this.props.intl.formatMessage({ id: "first and last name not found" }));
    }
    return this.context.capitalizeStr(this.props.intl.formatMessage({ id: "user information could not be found" }));
  };

  getEmail = () => {
    if (this.props.contact_info) {
      let email = this.props.contact_info?.contact?.email ?? this.props.contact_info?.email ?? "";
      if (email !== "") {
        return email;
      }
      return this.context.capitalizeStr(this.props.intl.formatMessage({ id: "no email" }));
    }
    return this.context.capitalizeStr(this.props.intl.formatMessage({ id: "user information could not be found" }));
  };

  getPhone = () => {
    if (this.props.contact_info) {
      let phone =
        this.props.contact_info?.contact?.mobile_phone ?? this.props.contact_info?.contact?.primary_phone ?? "";
      if (phone !== "") {
        return this.formatPhoneNumber(phone);
      }
      return this.context.capitalizeStr(this.props.intl.formatMessage({ id: "no mobile" }));
    }
    return this.context.capitalizeStr(this.props.intl.formatMessage({ id: "user information could not be found" }));
  };

  getEmailAndPhone = () => {
    return (
      <>
        <div className="fieldValue">{this.getEmail()}</div>
        <div className="fieldValueLight">{this.getPhone()}</div>
      </>
    );
  };

  formatPhoneNumber = str => {
    if (str?.length === 10) {
      const regexExpression = /^([\d]{3})([\d]{3})([\d]{4})$/;
      const match = str.match(regexExpression);
      if (match?.[1] && match?.[2] && match?.[3]) {
        return `(${match[1]}) ${match[2]}-${match[3]}`;
      }
    }
    return str;
  };

  render() {
    return (
      <Card className="settings-header" bordered={false}>
        {/* {!this.props.uploadVisible && (
          <Popconfirm
            overlayClassName="settingsPopconfirm"
            title={
              <p className="text-capitalize-first">
                <FormattedMessage
                  id={
                    this.state.deleteVisible
                      ? "are you sure you want to\n delete your profile picture"
                      : "are you sure you want to\n edit your profile picture"
                  }
                />
                ?
              </p>
            }
            visible={this.state.editVisible || this.state.deleteVisible}
            trigger="click"
            onConfirm={() => {
              if (this.state.editVisible) {
                this.props.changeUpload(true);
                this.setState({ editVisible: false });
              }

              if (this.state.deleteVisible) {
                this.props.onDelete();
                this.setState({ deleteVisible: false });
              }
            }}
            onCancel={() => this.setState({ editVisible: false, deleteVisible: false })}
            okText={
              <div className="text-capitalize-first">
                <FormattedMessage id="yes" />
              </div>
            }
            cancelText={
              <div className="text-capitalize-first">
                <FormattedMessage id="no" />
              </div>
            }
            placement="bottomLeft"
            style={{ marginTop: "60px" }}
          >
            <Tooltip
              placement="bottomLeft"
              title={
                <div className="text-capitalize">
                  <FormattedMessage id="edit image" />
                </div>
              }
              overlayClassName={
                (this.context.user_info?.photo_url ?? "") !== "" ? "editUserAvatarTooltip" : "userAvatarTooltip"
              }
            >
              <Button
                type="link"
                className="settings-profile-picture-upload-edit-button metaOverlayEdit"
                onClick={() => this.setState({ editVisible: true })}
                key="edit-profile-picture"
                onMouseEnter={() => this.props.setButtonHover(true)}
                onMouseLeave={() => this.props.setButtonHover(false)}
              >
                <EditOutlined style={{ fontSize: "16px" }} />
              </Button>
            </Tooltip>
            {(this.context.user_info?.photo_url ?? "") !== "" && (
              <Tooltip
                placement="bottomLeft"
                title={
                  <div className="text-capitalize">
                    <FormattedMessage id="delete image" />
                  </div>
                }
              >
                <Button
                  type="link"
                  className="settings-profile-picture-upload-remove-button metaOverlayDelete"
                  onClick={() => this.setState({ deleteVisible: true })}
                  key="remove-profile-picture"
                  onMouseEnter={() => this.props.setButtonHover(true)}
                  onMouseLeave={() => this.props.setButtonHover(false)}
                >
                  <DeleteOutlined style={{ fontSize: "16px" }} />
                </Button>
              </Tooltip>
            )}
          </Popconfirm>
        )} */}
        <Meta
          avatar={
            <>
              <Avatar size={72} className="userAvatar">
                {this.getInitials()}
              </Avatar>
            </>
          }
          title={<div className="textSemibold">{this.getName()}</div>}
          description={this.getEmailAndPhone()}
        />
      </Card>
    );
  }
}

export default withTheme(injectIntl(Header));
